import './sign-in-button.scss'
import { Icon } from '@vista-digital/occ-ui'
import { observer } from 'mobx-react'
import { SignInModal } from '@/common/components/signInModal/SignInModal'
import { signInModalStore } from '@/common/components/signInModal/signInModal.store'
import { useGetMember } from '@/common/hooks/useGetMember'
import { navigationService } from '@/common/services/navigation.service'
import { cx } from '@/common/utils/className'

export const SignInButton = observer(() => {
    const { isSignedIn, member } = useGetMember()
    const { openSignInModal } = signInModalStore
    const btnCls = cx('action-buttons__member', { 'bg-pink': isSignedIn, 'bg-off-white': !isSignedIn })

    const onClick = () => {
        if (isSignedIn) {
            navigationService.goToPageOrSubPage('Account', 'AccountOverview')
        } else {
            openSignInModal()
        }
    }

    return (
        <>
            <button className={btnCls} onClick={onClick}>
                {isSignedIn ? <span className={'initials'}>{member?.initials}</span> : <Icon name="user" />}
            </button>
            <SignInModal />
        </>
    )
})
